var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSortHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_sort_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sort_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83333333,21 L13.1666667,21 C13.625,21 14,20.625 14,20.1666667 C14,19.7083333 13.625,19.3333333 13.1666667,19.3333333 L9.83333333,19.3333333 C9.375,19.3333333 9,19.7083333 9,20.1666667 C9,20.625 9.375,21 9.83333333,21 Z M9,11.8333333 C9,12.2916667 9.375,12.6666667 9.83333333,12.6666667 L23.1666667,12.6666667 C23.625,12.6666667 24,12.2916667 24,11.8333333 C24,11.375 23.625,11 23.1666667,11 L9.83333333,11 C9.375,11 9,11.375 9,11.8333333 Z M9.83333333,16.8333333 L18.1666667,16.8333333 C18.625,16.8333333 19,16.4583333 19,16 C19,15.5416667 18.625,15.1666667 18.1666667,15.1666667 L9.83333333,15.1666667 C9.375,15.1666667 9,15.5416667 9,16 C9,16.4583333 9.375,16.8333333 9.83333333,16.8333333 Z",
    id: "Shape",
    fill: "#5697B7",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortHover);
export default __webpack_public_path__ + "static/media/icon_sort_hover.59524d6124be96c8389c335637dcaefe.svg";
export { ForwardRef as ReactComponent };